import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Section } from '../../../a11y/headings/tagWrappers';
import { VisuallyHidden } from '../../../a11y';
import Heading from '../../../a11y/headings/Heading';
import SubmissionDetails from '../../../SubmissionDetails';
import TextContent from '../../Details/_partials/TextContent';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import PremiumCover from '../_partials/PremiumCover';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import JournalViewer from '../../../DaEditorWrapper/Viewer/Journal';
import TextRenderer from '../../../TextRenderer';
import Stats from '../../../SubmissionDetails/_partials/Stats';
import s from './Literature.scss';
var LiteratureContent = function (_a) {
    var textContent = _a.deviation.textContent, deviation = _a.deviation, _b = _a.withArtist, withArtist = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isPremiumLocked = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData).isPremiumLocked;
    var isMobile = useContext(MobileContext);
    return (React.createElement(React.Fragment, null,
        withArtist && (React.createElement("div", { className: s['author-block'] },
            React.createElement(SubmissionDetails, { deviation: deviation }),
            !isMobile && ' ')),
        React.createElement("div", { className: s['stats'] },
            React.createElement(Stats, { deviation: deviation })),
        React.createElement(Section, { className: classnames(s['wrapper'], isPremiumLocked && s['wrapper-with-paywall']) },
            React.createElement(VisuallyHidden, null,
                React.createElement(Heading, null, t('deviationview.literature.a11y.heading.content'))),
            isExtendedLoaded &&
                (isPremiumLocked ? (React.createElement(React.Fragment, null,
                    React.createElement(TextRenderer, { className: s['text-content-pf'], textContent: textContent, reactViewer: JournalViewer, viewerKey: deviation.deviationId, legacyTheme: "journal" }),
                    React.createElement(PremiumCover, { deviation: deviation }))) : (React.createElement(TextContent, { className: s['text-content'], textContent: textContent, deviationId: deviation.deviationId }))))));
};
LiteratureContent.displayName = 'LiteratureContent';
export default LiteratureContent;
//# sourceMappingURL=Literature.js.map